<template>
  <div class="breadcrumbs">
    <ul class="pvd-list-group-root pvd-list-group--inline-always pvd-list-group--small">
      <li class="pvd-list-group__list-item" v-for="link in linkList" :key="link.index">
        <a :href="link.href" :id="link.id">{{ link.text }}</a>
      </li>
    </ul>

    <ul v-if="showActionLinks" class="pvd-list-group-root pvd-list-group--inline-always pvd-list-group--small">
      <li class="pvd-list-group__list-item action-item" v-for="link in actionsList" :key="link.index">
        <pvd-link
          pvd-class="action-link"
          :pvd-icon-left="link.iconLeft"
          :pvd-href="link.href"
          :pvd-text="link.text"
          pvd-disable-underline></pvd-link>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ClientConstants } from './../client.constants';

declare let app: any;

export interface BreadCrumb {
  text: string;
  href?: string;
  id?: string;
}

export type BreadCrumbs = Array<BreadCrumb>;

export default defineComponent({
  name: 'BreadCrumbs ',
  props: {
    linkList: { type: Array as PropType<BreadCrumbs>, required: true },
    showActionLinks: { type: Boolean, default: false, required: false }
  },
  data: () => {
    return {
      clientConstants: ClientConstants,
      actionsList: [
        {
          text: ClientConstants.PRINT,
          href: `${app?.hostUrl}${app?.fractionalCDsPrintPath}`,
          iconLeft: 'action__print'
        },
        {
          text: ClientConstants.EMAIL,
          href: `${app?.hostUrl}${app?.fractionalCDsEmailPath}`,
          iconLeft: 'action__email'
        },
        {
          text: ClientConstants.SHARE,
          href: `${app?.hostUrl}${app?.fractionalCDsSharePath}`,
          iconLeft: 'action__share'
        }
      ]
    };
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.breadcrumbs {
  height: 1rem;
  padding: 0.5rem 2rem;
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: $mobile-max) {
    display: none;
  }
}

.pvd-list-group__list-item {
  margin-left: 0.5rem !important;
  color: #666;
  font-size: 0.75rem;

  > a {
    text-decoration: none;
  }
}

.action-item {
  border-right: 0.0625em solid #666;
  margin-bottom: 0.5em;

  > * {
    margin-right: 0.5em;
  }

  @media only screen and (max-width: $mobile-max) {
    display: none;
  }
}
</style>
